import React, { useState, useEffect } from 'react';
import {  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {  Table } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
// import InsightChart from './InsightCharts';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getISOWeek, format } from 'date-fns';
// import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faVanShuttle, faEllipsis, faGrip, faUserGroup, faClock,  faMapLocationDot, faChartSimple , faNetworkWired} from '@fortawesome/free-solid-svg-icons';
// import msillgLogo from './msillg.svg';
import { BaseURL } from '../../Essentials/variables';
import './userLogs.css'
// import { Header } from '../../components/Header/Header';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Draggable from 'react-draggable';
import { LineWave } from 'react-loader-spinner';
import MainHeader from '../../Components/MainHeader/MainHeader';

function UserLogsBeta(props) {
    const [logsData, setLogsData] = useState([]);
    const [defaultTotalUsers, setDefaultTotalUsers] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalApiHits, setTotalApiHits] = useState(0);
    const [totalPoiHits, setTotalPoiHits] = useState(0);
    const [totalRoadHits, setTotalRoadHits] = useState(0);
    const [coverage, setCoverageHits] = useState(0);
    const [potential, setPotentialHits] = useState(0);
    const [summary, setsummayHits] = useState(0);
    const [isNoDataAvailable, setIsNoDataAvailable] = useState(false);
   

    const [totalOtherApiHits, setTotalOtherApiHits] = useState(0);
    const [dateStats, setDateStats] = useState([]);
    const [userApiStats, setUserApiStats] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [tableColumns, setTableColumns] = useState([]);
    const [filteredTableData, setFilteredTableData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedTimeInterval, setSelectedTimeInterval] = useState('daily'); // Step 1
  
    const [totalSessionTime, setTotalSessionTime] = useState(0);
    const [filteredChartData, setFilteredChartData] = useState([]);
    const [isUserSelected, setIsUserSelected] = useState(true);

    const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
    const [selectedMetrics, setSelectedMetrics] = useState('totalApiHits');
    const [logsLoader, setLogsLoader] = useState(false);

    const [userList, setUserList] = useState(userApiStats); // Initialize it with userApiStats
    const [userType, setUserType] = useState('ALL');

    const userTypeLabels = {
        DEALERS: "All Dealers",
        MSIL_USERS: "All MSIL Users",
    };
    const onStart = (e) => {
        setDragStartPos({ x: e.screenX, y: e.screenY });
    };

    const onStop = (e) => {
        const dragX = Math.abs(dragStartPos.x - e.screenX);
        const dragY = Math.abs(dragStartPos.y - e.screenY);
        if (dragX < 5 || dragY < 5) {
            // console.log(`click with drag of ${dragX}, ${dragY}`);
            // onClick functionality here
            openApiStatsModal();
        } else {
            // console.log(`click cancelled with drag of ${dragX}, ${dragY}`);
        }
    };

    const [showApiStatsModal, setShowApiStatsModal] = useState(false);
    const PRESS_TIME_UNTIL_DRAG_MS = 250;
    const openApiStatsModal = () => {
        // if(isDragging===true){
        //     return;
        // }
        setShowApiStatsModal(!showApiStatsModal);
    };

    const closeApiStatsModal = () => {
        setShowApiStatsModal(false);
    };


    const handleDownloadCSV = () => {
        const csvData = tableToCSV(filteredTableData);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'table_data.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const tableToCSV = (data) => {
        const headers = tableColumns.map((columnName) => columnName);
        const rows = data.map((row) => tableColumns.map((columnName) => row[columnName]));

        const csvArray = [headers, ...rows].map((row) => row.join(','));
        return csvArray.join('\n');
    };

    
    useEffect(() => {
        let totalUsersCount = 0;
        if (!selectedUser) {
            totalUsersCount = dateStats.reduce((total, data) => total + data.totalUsers, 0);
        } else {
            totalUsersCount = dateStats
                .filter((data) => data.date !== selectedUser)
                .reduce((total, data) => total + data.totalUsers, 0);
        }
        setDefaultTotalUsers(totalUsersCount);
    }, [selectedUser, dateStats]);
   
    useEffect(() => {
        setLogsLoader(true)
        fetch(`${BaseURL}userLogs`, {  //https://dev.msilruralmaps.com/api/UserLogs
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': localStorage.getItem('token'),
            },
        })
            .then((response) => response.json())
            .then((data) => { setLogsData(data); return true; })
            .then((res) => { setLogsLoader(false) })
    }, [])

    useEffect(() => {

        // console.log('Data from data.log:', logsData);
        if (logsData.length > 0) {
            const filteredData = logsData.filter((item) => {
                const itemDate = new Date(item.date);
                const isUserMatch = !selectedUser || item.ID === selectedUser;
                // const isDateRangeMatch = !startDate || !endDate || (itemDate >= startDate && itemDate <= endDate);
                const isStartDateMatch = !startDate || itemDate >= startDate;
                const isEndDateMatch = !endDate || itemDate <= endDate;
                return isUserMatch && isStartDateMatch && isEndDateMatch;
            }).filter((u) => {
                if (userType === "DEALERS") {
                    return u.ID?.toLowerCase().startsWith("dealer:");
                }
                if (userType === "MSIL_USERS") {
                    return !u.ID?.toLowerCase().startsWith("dealer:");
                }
                return true; // if no userType filter
            });

            const uniqueUserIDs = [...new Set(filteredData.map((item) => item.ID))];
            // setUserApiStats(uniqueUserIDs.map((userID) => ({ userID, apiNames: [] })));
            const updatedUserApiStats = uniqueUserIDs.map((userID) => {
                // You can determine or initialize `apiNames` for each user based on your application logic.
                // For example, you can fetch it from your data source or set it to an empty array.
                const apiNames = []; // Replace with your logic
              
                return { userID, apiNames };
              });
              
              if (!deepObjectsAreEqual(updatedUserApiStats, userApiStats)) {
                setUserApiStats(updatedUserApiStats);
              }
            const totalApiHitsCount = filteredData.reduce((total, item) => {
                const apiCounts = item.totalApiCounts;
                const apiCountValues = Object.values(apiCounts);
                const apiTotal = apiCountValues.reduce((apiTotal, count) => apiTotal + count, 0);
                return total + apiTotal;
            }, 0);
            const totalPoiHitsCount = filteredData.reduce((total, item) => {
                // console.log('item.totalApiCounts.dealerPoi', item.totalApiCounts.dealerPoi || 0);
                return total + (item.totalApiCounts.poi || 0) + (item.totalApiCounts.dealerPoi || 0);
            }, 0);

            const totalRoadHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.roadnetworks || 0);
            }, 0);

            const totalPoiVillageHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.poiredshift || 0);
            }, 0);
            

            const totalCoverageHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.Coverage || 0);
            }, 0);
            const totalSummaryHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.summary || 0);
            }, 0);
            const totalPotentialHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.potential || 0);
            }, 0);
            const totalUsersCount = selectedUser ? 1 : uniqueUserIDs.length;
            
            const totalCustomerHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.customer || 0);
            }, 0);
            const totalMapFilterHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.mapfilter || 0);
            }, 0);
            
            const totalDealerHitsCount = filteredData.reduce((total, item) => {
                return total + (item.totalApiCounts.dealer || 0);
            }, 0);
            const excludedApis = ["poi", "summary", "dealerPoi", "Coverage", "potential", "mapfilter"];
            // console.log('filtered data', filteredData)
            const totalOtherApiHitsCount = filteredData.reduce((total, item) => {
                const apiCounts = item.totalApiCounts;
                const apiCountWithoutExcluded = Object.keys(apiCounts)
                    .filter(api => !excludedApis.includes(api))
                    .reduce((subTotal, api) => subTotal + apiCounts[api], 0);
                return total + apiCountWithoutExcluded;
            }, 0);
            // console.log('otherAPiCount', totalOtherApiHitsCount)
            setTotalOtherApiHits(totalOtherApiHitsCount)
                    setTotalApiHits(totalApiHitsCount);
                    setTotalUsers(totalUsersCount);
                    setTotalRoadHits(totalRoadHitsCount);
                    setTotalPoiHits(totalPoiHitsCount);
                    setCoverageHits(totalCoverageHitsCount)
                    setPotentialHits(totalPotentialHitsCount)
                    setsummayHits(totalSummaryHitsCount);
          
            
            
            
            const uniqueApiColumns = new Set();
            filteredData.forEach((item) => {
                const { totalApiCounts } = item;
                Object.keys(totalApiCounts).forEach((apiColumn) => {
                    uniqueApiColumns.add(apiColumn);
                });
            });
            const apiColumnNames = Array.from(uniqueApiColumns);
            const formattedData = filteredData.map((item) => {
                const { date, ID, totalApiCounts, totalTime } = item;
                const totalTimeInMinutes = calculateTotalTimeInMinutes(totalTime);
                const rowData = {
                    date,
                    ID,
                    'totalTime (minutes)': totalTimeInMinutes,
                };
                apiColumnNames.forEach((apiColumn) => {
                    rowData[apiColumn] = totalApiCounts[apiColumn] || 0;
                });
                return rowData;
            });
            const columns = ['date', 'ID', 'totalTime (minutes)', ...apiColumnNames];
            setTableColumns(columns);
            setTableData(formattedData);
            setFilteredChartData(formattedData);
            
            
            if (filteredData.length === 0) {
                setIsNoDataAvailable(true);
            } else {
                setIsNoDataAvailable(false);
            }

            const filteredUserList = selectedUser
            ? userApiStats.filter((user) => user.userID === selectedUser)
            : userApiStats;
          
                setUserList(filteredUserList);
              
          
        }
    }, [selectedUser, startDate, endDate, logsData,userApiStats, userType]);


    function deepArraysAreEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        
        for (let i = 0; i < arr1.length; i++) {
            const item1 = arr1[i];
            const item2 = arr2[i];
            
            if (Array.isArray(item1) && Array.isArray(item2)) {
                if (!deepArraysAreEqual(item1, item2)) return false;
            } else if (typeof item1 === 'object' && typeof item2 === 'object') {
                if (!deepObjectsAreEqual(item1, item2)) return false;
            } else if (item1 !== item2) {
                return false;
            }
        }
        
        return true;
    }
    
    function deepObjectsAreEqual(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        
        if (keys1.length !== keys2.length) return false;
        
        for (const key of keys1) {
            const val1 = obj1[key];
            const val2 = obj2[key];
            
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (!deepArraysAreEqual(val1, val2)) return false;
            } else if (typeof val1 === 'object' && typeof val2 === 'object') {
                if (!deepObjectsAreEqual(val1, val2)) return false;
            } else if (val1 !== val2) {
                return false;
            }
        }
        
        return true;
    }
    
    const calculateTotalTimeInMinutes = (totalTime) => {
        const timeParts = totalTime.split(', ');
        let totalMinutes = 0;

        for (const part of timeParts) {
            const [value, unit] = part.split(' ');

            if (unit === 'hour' || unit === 'hours') {
                totalMinutes += parseInt(value, 10) * 60;
            } else if (unit === 'minute' || unit === 'minutes') {
                totalMinutes += parseInt(value, 10);
            }
        }

        return totalMinutes;
    };



    useEffect(() => {
        if (selectedUser) {
            const filteredData = tableData.filter((item) => item.ID === selectedUser);
            const totalSessionTimeInMinutes = filteredData.reduce(
                (total, item) => total + item['totalTime (minutes)'],
                0
            );

            setTotalSessionTime(totalSessionTimeInMinutes);
            setFilteredTableData(filteredData);
        } else {
            setTotalSessionTime(0);
            setFilteredTableData(tableData);
        }
    }, [selectedUser, tableData]);

    const gradientText = {
        background: 'linear-gradient(45deg, #da251d, #da252d)',
        WebkitBackgroundClip: 'text',
        color: 'transparent',
        display: 'inline',
        // borderBottom: '2px solid #da252d',
        padding: '5px', /* Adjust padding for spacing */
        fontWeight: 'bold', /* Add some thickness to the text */
    };



    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };


    const handleTimeIntervalChange = (event) => {
        setSelectedTimeInterval(event.target.value); // Step 3
    };

    const handleMetricsChange = (event) => {
        setSelectedMetrics(event.target.value); // Step 3
    };

    const handleUserSelection = (event) => {
        const selectedUserID = event.target.value;
        setSelectedUser(selectedUserID);
        
    };


    const transformDataForChart = (filteredChartData, timeInterval) => {
        if (timeInterval === 'daily') {
            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    let { date, ...apiCounts } = data;
                    // console.log('transformed inside data', data)
                    const apiCountsWithoutTotalTime = Object.keys(apiCounts).reduce((filteredCounts, key) => {
                        if (key !== 'totalTime (minutes)' && typeof apiCounts[key] === 'number') {
                            filteredCounts[key] = apiCounts[key];
                        }
                        return filteredCounts;
                    }, {});

                    const totalApiHits = Object.values(apiCountsWithoutTotalTime)
                        .filter((value) => typeof value === 'number') // Filter out non-numeric values
                        .reduce((total, count) => total + count, 0);

                    if (!acc[date]) {
                        let formattedDate = moment(date).format('MMM DD,YYYY');
                        // console.log('formattedDate', date)
                        acc[date] = { date: formattedDate, totalApiHits };
                    } else {
                        acc[date].totalApiHits += totalApiHits;
                    }
                    // console.log('acc', acc)
                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Daily):", transformedData);

            return transformedData;
        }
        else if (timeInterval === 'weekly') {
            const getWeekRange = (weekStartDate, weekEndDate, month, weekNumber) => {
                const formattedStartDate = moment(weekStartDate).format('MMM, D');
                const weekRange = `${formattedStartDate} - ${month} ${weekNumber === 1 ? '1st' : weekNumber === 2 ? '2nd' : weekNumber === 3 ? '3rd' : `${weekNumber}th`} week`;
                return weekRange;
            };

            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    const week = getISOWeek(new Date(data.date));
                    const year = new Date(data.date).getFullYear();
                    const month = format(new Date(data.date), 'MMM');
                    let weekOfMonth = Math.ceil(
                        (new Date(data.date).getDate() + 6 - new Date(year, new Date(data.date).getMonth(), 1).getDay()) / 7
                    );
                    weekOfMonth -= 1;
                    const weekStartDate = new Date(year, new Date(data.date).getMonth(), (weekOfMonth - 1) * 7+1);
                    const weekEndDate = new Date(year, new Date(data.date).getMonth(), weekOfMonth * 7);

                    const weekLabel = `Week ${weekOfMonth}: ${month} ${weekStartDate.getDate()} - ${month} ${weekEndDate.getDate()}, ${year}`;

                    if (!acc[weekLabel]) {
                        acc[weekLabel] = {
                            date: weekLabel,
                            totalApiHits: 0,
                            startDate: weekStartDate.toISOString().slice(0, 10),
                            endDate: weekEndDate.toISOString().slice(0, 10),
                        };
                    }

                    acc[weekLabel].totalApiHits += Object.entries(data)
                        .filter(([key, value]) => key !== 'totalTime (minutes)' && typeof value === 'number')
                        .reduce((total, [, count]) => total + count, 0);

                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Weekly):", transformedData);

            return transformedData;
        }
        else if (timeInterval === 'monthly') {
            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    let month = new Date(data.date).toISOString().slice(0, 7);
                    month = moment(month).format('MMM,YY');
                    if (!acc[month]) {
                        acc[month] = {
                            date: month,
                            totalApiHits: 0,
                            startDate: null,
                            endDate: null,
                        };
                    }

                    const year = new Date(data.date).getFullYear();
                    const monthNumber = new Date(data.date).getMonth();
                    const monthStartDate = new Date(year, monthNumber, 1);
                    const monthEndDate = new Date(year, monthNumber + 1, 0);

                    acc[month].startDate = monthStartDate.toISOString().slice(0, 10);
                    acc[month].endDate = monthEndDate.toISOString().slice(0, 10);

                    acc[month].totalApiHits += Object.entries(data)
                        .filter(([key, value]) => key !== 'totalTime (minutes)' && typeof value === 'number') // Exclude totalTime (minutes) and non-numeric values
                        .reduce((total, [, count]) => total + count, 0);

                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Monthly):", transformedData);

            return transformedData;
        }

        return [];
    };

    const transformDataForChart2 = (filteredChartData, timeInterval) => {
        if (timeInterval === 'daily') {
            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    let { date, ...otherData } = data;

                    const calculateTotalTime = Object.keys(otherData).reduce((filteredCounts, key) => {
                        if (key === 'totalTime (minutes)' && typeof otherData[key] === 'number') {
                            filteredCounts[key] = otherData[key];
                        }
                        return filteredCounts;
                    }, {});

                    const totalTime = Object.values(calculateTotalTime)
                        .filter((value) => typeof value === 'number') // Filter out non-numeric values
                        .reduce((total, count) => total + count, 0);

                    if (!acc[date]) {
                        let formattedDate = moment(date).format('MMM DD,YYYY');
                        // console.log('formattedDate', date)
                        acc[date] = { date: formattedDate, totalTime };
                    } else {
                        acc[date].totalTime += totalTime;
                    }
                    // console.log('acc', acc)
                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Daily):", transformedData);

            return transformedData;
        }
        else if (timeInterval === 'weekly') {
            const getWeekRange = (weekStartDate, weekEndDate, month, weekNumber) => {
                const formattedStartDate = moment(weekStartDate).format('MMM, D');
                const weekRange = `${formattedStartDate} - ${month} ${weekNumber === 1 ? '1st' : weekNumber === 2 ? '2nd' : weekNumber === 3 ? '3rd' : `${weekNumber}th`} week`;
                return weekRange;
            };

            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    const week = getISOWeek(new Date(data.date));
                    const year = new Date(data.date).getFullYear();
                    const month = format(new Date(data.date), 'MMM');
                    const weekOfMonth = Math.ceil(
                        (new Date(data.date).getDate() + 6 - new Date(year, new Date(data.date).getMonth(), 1).getDay()) / 7
                    );

                    const weekStartDate = new Date(year, new Date(data.date).getMonth(), (weekOfMonth - 1) * 7 + 1);
                    const weekEndDate = new Date(year, new Date(data.date).getMonth(), weekOfMonth * 7);

                    const weekLabel = `Week ${weekOfMonth}: ${month} ${weekStartDate.getDate()} - ${month} ${weekEndDate.getDate()}, ${year}`;

                    if (!acc[weekLabel]) {
                        acc[weekLabel] = {
                            date: weekLabel,
                            totalTime: 0,
                            startDate: weekStartDate.toISOString().slice(0, 10),
                            endDate: weekEndDate.toISOString().slice(0, 10),
                        };
                    }

                    acc[weekLabel].totalTime += Object.entries(data)
                        .filter(([key, value]) => key === 'totalTime (minutes)' && typeof value === 'number')
                        .reduce((total, [, count]) => total + count, 0);

                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Weekly):", transformedData);

            return transformedData;
        }
        else if (timeInterval === 'monthly') {
            const transformedData = Object.values(
                filteredChartData.reduce((acc, data) => {
                    let month = new Date(data.date).toISOString().slice(0, 7);
                    month = moment(month).format('MMM,YY');
                    if (!acc[month]) {
                        acc[month] = {
                            date: month,
                            totalTime: 0,
                            startDate: null,
                            endDate: null,
                        };
                    }

                    const year = new Date(data.date).getFullYear();
                    const monthNumber = new Date(data.date).getMonth();
                    const monthStartDate = new Date(year, monthNumber, 1);
                    const monthEndDate = new Date(year, monthNumber + 1, 0);

                    acc[month].startDate = monthStartDate.toISOString().slice(0, 10);
                    acc[month].endDate = monthEndDate.toISOString().slice(0, 10);

                    acc[month].totalTime += Object.entries(data)
                        .filter(([key, value]) => key === 'totalTime (minutes)' && typeof value === 'number') // Exclude totalTime (minutes) and non-numeric values
                        .reduce((total, [, count]) => total + count, 0);

                    return acc;
                }, {})
            );

            // console.log("Transformed Data (Monthly):", transformedData);

            return transformedData;
        }

        return [];
    };
    useEffect(() => {

        if (startDate && endDate) {
            const filteredData = tableData.filter((item) => {
                const itemDate = new Date(item.date);
                return itemDate >= moment(startDate).startOf('day') && itemDate <= moment(endDate).endOf('day');
            });
            setFilteredTableData(filteredData);
        } else {

            setFilteredTableData(tableData);
        }
    }, [startDate, endDate, tableData]);

    return (
        <main style={{
            backgroundImage: " url(background.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            // height: "100vh",
            overflowX: "hidden",
            minHeight: "100vh",
          }} className='main-container'>
            <MainHeader  nav={props.nav} />
            {/* <Header /> */}
            {logsLoader && <div className=' bg-none ' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 'auto', height: '100vh' }}> <LineWave
                visible={logsLoader}
                height="200"
                width="200"
                ariaLabel="hourglass-loading"
                wrapperStyle={{}}
                wrapperClass=""
                color='#fff'

                
            />
            
                {logsLoader === true && <h1 style={{color:"white"}}>Loading Data...</h1>}</div>}
           
            {logsLoader === false && <div className='container'>
           

                            <div className="relative flex items-center justify-center">
                                <h3 className="my-4 text-slate-100 text-5xl">LOGS DASHBOARD</h3>
                                <select
                                    className="absolute right-0 rounded-lg border border-gray-300 bg-gray-800 text-slate-100 px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={userType}
                                    onChange={e => {
                                        const type = e.target.value;
                                            setUserType(type);
                                    }}
                                >
                                    <option value="ALL">ALL</option>
                                    <option value="DEALERS">DEALERS</option>
                                    <option value="MSIL_USERS">MSIL USERS</option>
                                </select>
                            </div>

                <div className='row'>
                    <div className='col-md-12'>
                        
                            <div className='date-range-picker'>
                                <label className='form-label' style={{ color: '#FFF' }}>Select Date Range: </label>
                                <DatePicker
                                    selected={startDate}
                                    selectsStart
                                    startDate={startDate}
                                    endDate={endDate}
                                    placeholderText='Start Date'
                                    className='form-control'
                                    onChange={handleStartDateChange}
                                />
                                <DatePicker
                                    selected={endDate}
                                    selectsEnd
                                    startDate={startDate}
                                    endDate={endDate}
                                    placeholderText='End Date'
                                    className='form-control'
                                    onChange={handleEndDateChange}
                                />
                               
                                <div className='user-selection mb-3'>
                                    <label className='form-label label-2 text-white'>Select User: </label>
                                    <select className='form-select' value={selectedUser} onChange={handleUserSelection}>
                                        <option value=''>
                                                    {userTypeLabels[userType] || "All Users"}
                                        </option>
                                        {userList.map((userStats) => (
                                            <option key={userStats.userID} value={userStats.userID}>
                                                {userStats.userID}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            </div>
                      

                    </div>
                </div>
                {!selectedUser && (
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className='card card-api mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>TOTAL API HITS</h3>
                                    {/* <BsFillGrid3X3GapFill className='card_icon' /> */}
                                    <FontAwesomeIcon icon={faGrip} style={{color: '#FF7676' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalApiHits}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            {isUserSelected && (
                                <div className='card card-users mb-3'>
                                    <div className='card-inner'>
                                        <h3 className='card-title'>TOTAL USERS</h3>
                                        {/* <BsPeopleFill className='card_icon' /> */}
                                        <FontAwesomeIcon icon={faUserGroup} style={{color: '#2E4374' }} className='card_icon' />
                                    </div>
                                    <div className='card-body'>
                                        <h1 className='card-text'>{totalUsers}</h1>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-road mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>ROAD NETWORK</h3>
                                    <FontAwesomeIcon icon={faVanShuttle} style={{color: '#EE9322' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalRoadHits}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>TOTAL POI HIT</h3>
                                    <FontAwesomeIcon icon={faLocationDot} style={{color: '#C70039' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalPoiHits}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>COVERAGE</h3>
                                    <FontAwesomeIcon icon={faNetworkWired} style={{color: '#A7D397' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{coverage}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>POTENTIAL</h3>
                                    <FontAwesomeIcon icon={faChartSimple} style={{color: '#2E4374' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{potential}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>REPORT</h3>
                                    <FontAwesomeIcon icon={faMapLocationDot} style={{color: '#4B527E' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{summary}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>OTHER API HIT</h3>
                                    <FontAwesomeIcon icon={faEllipsis} style={{color: '#2E4374' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalOtherApiHits}</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                )}
                {selectedUser && (
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className='card card-api mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>TOTAL API HITS</h3>
                                    {/* <BsFillGrid3X3GapFill className='card_icon' /> */}
                                    <FontAwesomeIcon icon={faGrip} style={{color: '#FF7676' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalApiHits}</h1>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className='card card-api mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>TOTAL TIME(min)</h3>
                                    <FontAwesomeIcon icon={faClock} style={{color: '#2E4374' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalSessionTime}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-road mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>ROAD NETWORK</h3>
                                    <FontAwesomeIcon icon={faVanShuttle} style={{color: '#EE9322' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalRoadHits}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>TOTAL POI HIT</h3>
                                    <FontAwesomeIcon icon={faLocationDot} style={{color: '#C70039' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalPoiHits}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>COVERAGE</h3>
                                    <FontAwesomeIcon icon={faNetworkWired} style={{color: '#A7D397' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{coverage}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>POTENTIAL</h3>
                                    <FontAwesomeIcon icon={faChartSimple} style={{color: '#2E4374' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{potential}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>REPORT</h3>
                                    <FontAwesomeIcon icon={faMapLocationDot} style={{color: '#4B527E' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{summary}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='card card-poi mb-3'>
                                <div className='card-inner'>
                                    <h3 className='card-title'>OTHER API HIT</h3>
                                    <FontAwesomeIcon icon={faEllipsis} style={{color: '#2E4374' }} className='card_icon' />
                                </div>
                                <div className='card-body'>
                                    <h1 className='card-text'>{totalOtherApiHits}</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                )}
                <div className='row'>
                    <div className='col-md-12'>

                        <div className="graph-parameter-selector-container">
                            <div className='time-interval-selector'>
                                <label className='form-label' style={{ color: '#FFF' }}>Select Time Interval: </label>
                                <select
                                    value={selectedTimeInterval}
                                    onChange={handleTimeIntervalChange} // Step 3
                                    className='form-select'
                                >
                                    <option value='daily'>Daily</option>
                                    <option value='weekly'>Weekly</option>
                                    <option value='monthly'>Monthly</option>
                                </select>
                            </div>
                            <div className='time-interval-selector'>
                                <label className='form-label' style={{ color: '#FFF' }}>Select Metrics: </label>
                                <select
                                    value={selectedMetrics}
                                    onChange={handleMetricsChange} // Step 3
                                    className='form-select'
                                >
                                    <option value='totalApiHits'>API Hits</option>
                                    <option value='totalTime'>Time Spent</option>
                                </select>
                            </div>
                        </div>
                        {/* <DropdownButton
            as={ButtonGroup}
            key={'Danger'}
            id={`dropdown-variants-Danger`}
            variant={'danger'}
            title={'Danger'}
          >
            <Dropdown.Item eventKey="1">Action</Dropdown.Item>
            <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
            <Dropdown.Item eventKey="3" active>
              Active Item
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item eventKey="4">Separated link</Dropdown.Item>
          </DropdownButton> */}
                    </div>
                </div>
                {selectedMetrics === 'totalApiHits' && (<div className='row'>
                    <div className='col-md-12'>
                        {/* {console.log('filteredChartData:', filteredChartData)} */}
                        <div className='chart card2 p-4'>
                            <ResponsiveContainer width='100%' height={300}>

                                <BarChart data={transformDataForChart(filteredChartData, selectedTimeInterval)}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                                    <XAxis dataKey="date" />
                                    <YAxis dataKey="totalApiHits" />
                                    <Tooltip />
                                    <Legend verticalAlign="top" align="right" />
                                    <Bar
                                        dataKey="totalApiHits"
                                        fill="#171b8f"
                                        // fill="#ff4d4d"
                                        name="Total API Hits"
                                        animationBegin={0}
                                        animationDuration={1000}
                                    />
                                </BarChart>

                            </ResponsiveContainer>

                        </div>
                    </div>

                </div>)}
                {selectedMetrics === 'totalTime' && (<div className='row'>
                    <div className='col-md-12'>
                        {/* {console.log('filteredChartData:', filteredChartData)} */}
                        <div className='chart card2 p-4'>
                            <ResponsiveContainer width='100%' height={300}>

                                <BarChart data={transformDataForChart2(filteredChartData, selectedTimeInterval)}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                                    <XAxis dataKey="date" />
                                    <YAxis dataKey="totalTime" />
                                    <Tooltip />
                                    <Legend verticalAlign="top" align="right" />
                                    <Bar
                                        dataKey="totalTime"
                                        fill="#171b8f"
                                        name="Total Time (in mins)"
                                        animationBegin={0}
                                        animationDuration={1000}
                                    />
                                </BarChart>

                            </ResponsiveContainer>

                        </div>
                    </div>

                </div>)}
                <Draggable
                    onStart={onStart}
                    onStop={onStop}
                >
                    <button
                        className='btn btn-danger-1 floating-button'
                        data-bs-toggle="modal"
                        data-bs-target="#apiStatsModal"
                    // onClick={openApiStatsModal}

                    >
                        API Stats
                    </button>
                </Draggable>

                {/* {showApiStatsModal && */}
                <Modal
                    show={showApiStatsModal}
                    onHide={openApiStatsModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    scrollable={true}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            API Stats for User: {selectedUser}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='table-container'>
                            <div className='user-api-stats card2 '>
                                {/* <h2 className='api-stats-header mb-4 '>API Stats for User: {selectedUser}</h2> */}
                                <div className='mb-3'>
                                    <button className='btn btn-danger-1' onClick={handleDownloadCSV}>
                                        Download CSV
                                    </button>
                                </div>
                                <Table
                                    dataSource={filteredTableData}
                                    columns={tableColumns.map((columnName) => ({
                                        title: columnName,
                                        dataIndex: columnName,
                                        key: columnName,
                                    }))}
                                    pagination={{ pageSize: 5 }}
                                    scroll={{ x: true }}
                                // scroll={{ x: true, y: true }}
                                />
                            </div>

                        </div>
                    </Modal.Body>
                    {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
                </Modal>
            </div>}


        </main >
    );
}

export default UserLogsBeta;
